export default __webpack_public_path__ + "static/media/publication.230ff92e.jpg";